import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UserViewProps{
	
}

var UserView = (props: UserViewProps)=>{
	var { t } = useTranslation();
	useEffect(()=>{
		
	}, []);
	
	return <div>
		
	</div>
}

export default UserView;